import React from 'react'
import html from "../assets/html.png"
import react from "../assets/react.png"
import javascript from "../assets/javascript.png"
import github from "../assets/github.png"
import css from "../assets/css.png"
import python from "../assets/python.png"
import tailwind from "../assets/tailwind.png"





const Experience = () => {
    const techs = [
        {
            id: 1, 
            src: html,
            title: 'HTML',
            style: 'shadow-orange-500'
        },
        {
            id: 5, 
            src: github,
            title: 'Github',
            style: 'shadow-slate-500'
        },
        {
            id: 6, 
            src: python,
            title: 'Python',
            style: 'shadow-yellow-500'
        },
        {
            id: 2, 
            src: css,
            title: 'Css',
            style: 'shadow-blue-500'
        },
        {
            id: 3, 
            src: react,
            title: 'React',
            style: 'shadow-blue-500'
        },
        {
            id: 4, 
            src: javascript,
            title: 'Javascript',
            style: 'shadow-yellow-500'
        },
        {
            id: 5, 
            src: tailwind,
            title: 'Tailwind',
            style: 'shadow-blue-500'
        },
    ]
  return (
    <div name='technologies' className='bg-gradient-to-b from-gray-800 to-black w-full h-screen'>

        <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
            <p className='text-4xl tracking-wide font-bold border-b-4 border-gray-500 p-2 inline'>Technologies</p>
            <p className='py-6'>I've worked with these technologies:</p>



        <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>
            {
                techs.map(({id, src, title, style}) => (
                    <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style} `}>
                    <img className="w-20 mx-auto" src={src} alt="" />
                    <p className='mt-4'>{title}</p>
                    </div>
                ))

            }

        </div>



        </div>
    </div>
  )
}

export default Experience